export const VIEW_STATE = {
  CLEAR_SUCCESS_STATE: "VIEW_STATE_CLEAR_SUCCESS_STATE",
  CLEAR_ERROR_STATE: "VIEW_STATE_CLEAR_ERROR_STATE"
};
